/**
 * Test IDs for QA automation.
 */
export const testIds = {
  deductionRuleFormLabel: "deduction-rule-form-label",
  deductionRuleFormMethod: "deduction-rule-form-method",
  deductionRuleFormMethodOption: "deduction-rule-form-method-option",
  deductionRuleFormAmount: "deduction-rule-form-amount",
  deductionRuleFormPeriod: "deduction-rule-form-period",
  deductionRuleFormPeriodUnit: "deduction-rule-form-period-unit",
  deductionRuleFormPeriodUnitOption: "deduction-rule-form-period-unit-option",
} as const;
